<template>
  <transition name="slide">
    <v-card
      v-if="show"
      class="drawer elevation-7 gray-7--text"
    >
      <Header :user="user" @close="closeDrawer" />

      <transition name="fade">
        <Preview v-if="isSuccess" :user="userData" />
      </transition>

      <v-layout
        v-if="isLoading"
        class="text-xs-center fill-height--adjust"
        align-center
        justify-center
        row
        fill-height
      >
        <v-progress-circular indeterminate color="accent" />
      </v-layout>
    </v-card>
  </transition>
</template>

<script>
import { mapActions } from 'vuex'
import { STATUS_IS_LOADING, STATUS_SUCCESS, STATUS_FAILED } from 'utils/constants'
import { calcContentHeight, isObject, isArray } from 'utils/functions'
import Header from './Header'
import Preview from './Preview'

export default {
  name: 'UserDrawer',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    user: {
      type: Object
    }
  },
  components: {
    Header,
    Preview
  },
  computed: {
    isLoading () {
      return this.currentStatus === STATUS_IS_LOADING
    },

    isSuccess () {
      return this.currentStatus === STATUS_SUCCESS
    },

    isFailed () {
      return this.currentStatus === STATUS_FAILED
    }
  },
  data () {
    return {
      namespace: 'Views.UserPage',
      currentStatus: null,
      userData: null
    }
  },
  methods: {
    ...mapActions({
      successAlert: 'snackbarAlert/success',
      errorAlert: 'snackbarAlert/error',
      showAlert: 'snackbar/show'
    }),

    isValidObject (val) {
      return isObject(val)
    },

    isValidArray (val) {
      return isArray(val)
    },

    calcContentHeight () {
      this.contentHeight = calcContentHeight()
    },

    closeDrawer () {
      this.$emit('closeDrawer')
    },

    async getUserById (id) {
      if (this.currentStatus === STATUS_IS_LOADING) return

      if (this.user && this.user.corporateId) {
        this.currentStatus = STATUS_IS_LOADING

        try {
          const { data: res } = await this.$apiService.users.getById(this.user.corporateId, {
            showDetails: true
          })

          if (res && !res.valid) {
            const message = this.isValidArray(res.reasons) ? res.reasons[0] : this.$t('Common.genericErrorMsg')
            this.errorAlert(message)
            this.currentStatus = STATUS_FAILED
            this.closeDrawer()
          } else if (!res.content) {
            this.errorAlert(this.$t(`${this.namespace}.notFound`))
            this.currentStatus = STATUS_FAILED
            this.closeDrawer()
          } else {
            this.userData = res.content
            this.currentStatus = STATUS_SUCCESS
          }
        } catch (err) {
          console.log('ERROR:', err)
          this.currentStatus = STATUS_FAILED
        }
      }
    }
  },
  watch: {
    async show (val) {
      if (val) {
        this.$ga.page('/drawer/usuarios/visualizar')
        await this.getUserById()
      }
    },

    user: {
      deep: true,
      handler () {
        this.show && this.getUserById()
      }
    }
  },
  mounted () {
    this.calcContentHeight()
    window.addEventListener('resize', this.calcContentHeight)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.calcContentHeight)
  }
}
</script>

<style lang="scss" scoped>
.content__title__container {
  padding: 6px 24px 22px;
  text-align: center;
}

.content__title {
  color: #4a4b4a;
  font-family: Montserrat,sans-serif;
  font-size: 14px;
  font-weight: 800;
}
</style>
